import { ShoppingCart } from "lucide-react";
import { Link } from "react-router-dom";
import { useCart } from "@/context/CartContext";

const FloatingCheckout = () => {
  const { cartItems, totalPrice } = useCart();
  const totalItems = cartItems.length;
  
  if (totalItems === 0) return null;

  return (
    <div className="md:hidden fixed bottom-16 left-0 right-0 z-40 mx-4 pointer-events-none animate-fade-up">
      <div className="bg-[#004B57] text-white rounded-full shadow-[0_8px_40px_rgba(0,59,70,0.3)] p-2 pr-4 flex items-center justify-between pointer-events-auto border border-white/10">
        <div className="flex items-center gap-3">
          <div className="bg-white/10 rounded-full w-10 h-10 flex items-center justify-center relative">
            <ShoppingCart size={18} />
            <span className="absolute -top-1 -right-1 bg-[#006C73] text-white text-[10px] font-bold w-5 h-5 rounded-full flex items-center justify-center border-2 border-[#004B57]">
              {totalItems}
            </span>
          </div>
          <div className="flex flex-col">
            <span className="text-[10px] uppercase tracking-widest font-black opacity-60">TOTAL PRICE</span>
            <span className="text-sm font-black leading-none">৳{totalPrice}</span>
          </div>
        </div>
        
        <Link 
          to="/checkout"
          className="bg-[#006C73] text-white hover:bg-[#009EAE] px-6 py-3.5 rounded-full text-xs font-black uppercase tracking-widest shadow-lg transition-all active:scale-95 flex items-center justify-center min-h-[48px]"
        >
          CHECKOUT
        </Link>

      </div>
    </div>
  );
};

export default FloatingCheckout;
